import React, { useState, useContext, useEffect } from 'react'
import { SidebarContext } from '../../context/SidebarContext.js';
import { authContext } from '../../context/AuthContext.js';
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import AccountDropdown from '../../components/Account/AccountDropdown';
import LogoutUser from '../../components/Authorization/Logout.js';
import Bread_Bskt from "../../images/Bread_Bskt.png"
import { useNavigate } from 'react-router-dom';
import UserLocation from '../../components/Account/UserLocation.jsx';

export default function NonMobileHeader({ usrName, reload }) {

    const { toggleSidebar, isOpen } = useContext(SidebarContext)
    const { logout, userRole } = useContext(authContext)
    const navigate = useNavigate()

    const [accntBttn, setAccntBttn] = useState(false)
    const [logoTarget, setLogoTarget] = useState(null)
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 850); // Adjust the width as per your mobile breakpoint    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 850);
        };

        // Add event listener on mount
        window.addEventListener("resize", handleResize);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleAcctDrop = ({ target }) => {

        setAccntBttn(!accntBttn)
        setLogoTarget(target)
    }

    const handleClose = async (selection) => {
        setAccntBttn(!accntBttn)


        switch (selection) {
            case 'logout':
                const success = await logout()
                if (success) {
                    return logout(true)
                }
                else { return setOpenSnackbar(true) }

            case 'settings':
                if (isOpen) {
                    toggleSidebar()
                }

                navigate("/account-settings/user-profile")
                //navigate to the account page -- somehow disable the sidebar
                break;
        }
    }

    const goHome = () => {

        if (!isOpen) {
            toggleSidebar()
        }
        navigate("/")
    }

    const handleLocChange = () => {
        reload()
    }

    const handleSidebarMenuClick = () => {
        toggleSidebar()
    }

    return (
        <div className="header">

            < div className='row' style={{ alignItems: "center" }}>
                < div className={isMobile ? 'col-11 small-logo' : 'col-11 '}>
                    <div className='row' style={{ alignItems: 'center' }}>
                        <div className='col-2' id='colpse-sdbr' style={{ alignSelf: "center", maxWidth: '103px', minWidth: '95px', padding: '0' }}>
                            {isOpen ? <MenuOpenOutlinedIcon sx={{ color: '#5f6368', marginLeft: "40px", height: '1.1em', width: '1.1em', cursor: 'pointer', '@media (max-width:1080px)': { marginLeft: "27px" } }}
                                onClick={handleSidebarMenuClick} /> :
                                <MenuOutlinedIcon sx={{ color: '#5f6368', marginLeft: "40px", height: '1.1em', width: '1.1em', cursor: 'pointer', '@media (max-width:1080px)': { marginLeft: "27px" } }}
                                    onClick={handleSidebarMenuClick} />
                            }
                        </div>
                        <div className='col-10 logo' style={{ paddingLeft: '0', marginLeft: 0 }} >
                            <h4> <img src={Bread_Bskt} style={{ width: '45px', height: '45px' }} onClick={goHome} /> Bread Bskt </h4>
                        </div>

                    </div>
                </div>
                <div className='col-1' style={{ position: "relative" }}>
                    <div className='row' style={{ alignItems: 'center' }}>
                        {/* <div className='col-8'>
                            <UserLocation locationOptns={locationAccess} change={handleLocChange} />
                        </div> */}
                        <div className='col-2' style={{ borderLeft: 'solid lightgray' }}>
                            <button type='button' className='blank-bttn' style={{ position: 'relative', left: "10px" }} onClick={(e) => handleAcctDrop(e)} >

                                <Avatar sx={{ background: 'black', color: "white" }}>{usrName[0]}</Avatar>
                            </button>
                        </div>
                    </div>
                    {accntBttn && <AccountDropdown target={logoTarget} close={handleClose} />}
                </div>

                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={() => setOpenSnackbar(false)}>
                    <Alert
                        onClose={() => setOpenSnackbar(false)}
                        severity="error"
                    >
                        Unable to log out!
                    </Alert>
                </Snackbar>

            </div>
        </div >
    )
}